import { cn } from "../../lib/cn";

const sizes = {
  sm: "px-2 py-1.5 text-xs",
  md: "px-3 py-1.5 text-sm",
};

export function SegmentedControl({
  options,
  value,
  onChange,
  className,
  ariaLabel = "Options",
  fullWidth = false,
  variant = "default",
  size = "md",
  disabled = false,
}) {
  return (
    <div
      className={cn(
        "rounded-xl border border-border bg-muted/50 p-1",
        fullWidth ? "grid w-full gap-1" : "inline-flex gap-1",
        fullWidth && options.length <= 4 && "grid-cols-4",
        fullWidth && options.length === 3 && "grid-cols-3",
        fullWidth && options.length === 2 && "grid-cols-2",
        className,
      )}
      role="tablist"
      aria-label={ariaLabel}
    >
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={disabled}
            onClick={() => onChange?.(opt.value)}
            className={cn(
              "font-medium rounded-lg transition-colors whitespace-nowrap",
              sizes[size] || sizes.md,
              fullWidth && "w-full text-center",
              active
                ? variant === "brand"
                  ? "bg-brand text-white shadow-sm"
                  : "bg-card text-foreground shadow-subtle"
                : "text-muted-foreground hover:text-foreground hover:bg-muted/60",
              disabled && "opacity-60 cursor-not-allowed",
            )}
          >
            {opt.tabLabel || opt.label}
          </button>
        );
      })}
    </div>
  );
}
